import React from 'react'
import { Box } from '@mui/material'
import { UserGroupIcon } from '@heroicons/react/24/outline'
import { INTERAX_COLORS, TYPOGRAPHY } from '../../../../constants/interaxColors'

export interface SprintMemberInitialsProps {
  initials: string[]
  remainingCount: number
  className?: string
}

/**
 * SprintMemberInitials - Displays member avatars with initials
 * Shows first 3 members as circular avatars, with count for remaining members
 */
export const SprintMemberInitials: React.FC<SprintMemberInitialsProps> = ({
  initials,
  remainingCount,
  className = ''
}) => {
  if (initials.length === 0) {
    return null
  }

  return (
    <Box
      className={className}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5
      }}
    >
      <UserGroupIcon
        style={{
          width: 16,
          height: 16,
          color: INTERAX_COLORS.thunderGrey
        }}
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5
        }}
      >
        {initials.map((initial, index) => (
          <Box
            key={index}
            sx={{
              width: 24,
              height: 24,
              borderRadius: '50%',
              backgroundColor: INTERAX_COLORS.sun20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              ...TYPOGRAPHY.body3,
              fontSize: '10px',
              fontWeight: 600,
              color: INTERAX_COLORS.sun
            }}
          >
            {initial}
          </Box>
        ))}
        {remainingCount > 0 && (
          <Box
            component="span"
            sx={{
              ...TYPOGRAPHY.body3,
              fontSize: '12px',
              fontWeight: 600,
              color: INTERAX_COLORS.thunderGrey
            }}
          >
            +{remainingCount}
          </Box>
        )}
      </Box>
    </Box>
  )
}
